import * as yup from 'yup';

import './fixMessages';

export default yup.object().shape({
  name: yup.string().trim().max(80).nullable(),
  description: yup.string().trim().max(4096).required(),
});
